<div  [hidden]="isClientManager" class="upload-description-section">
    <label for="Description">
        <textarea placeholder="Enter description here (optional)" [(ngModel)]='uploadDescription' size="5" rows="3"
            cols="91" no-special-chars="#!$%^<>+='" name="Description" class="description-text-section" maxlength="500">
        </textarea>
    </label>
</div>
<div *ngIf="showDocumentsList" [ngClass]="{'document-list-section': true, 'document-list-section-cm' : isClientManager }"  class="datatableAlign">
    <div class="tableFixHead">
        <ngx-datatable class="" [rows]="surveyDocuments" [headerHeight]="0" [rowHeight]="45">
            <!-- [ngStyle]="{'height': roleId != clientManagerRole ? 25 +'vh' : auto }"> -->
            <ngx-datatable-column [width]="30">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <i class="fa fa-file"></i>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="name" [width]="300">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div [title]="isRcnSurveyApp ? '' : 'Click to export file'" (click)="downloadDocument(row)">
                        <button class="link-button">
                            {{row?.fileName?.length >= 37 ? row.fileName.substring(0,37).trimRight() + '...' : row?.fileName}}
                        </button>
                    </div>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [width]="30">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <button *ngIf="!isRcnSurveyApp" class="download-btn" (click)="downloadDocument(row)">
                        <i class="fas fa-cloud-download"></i>
                    </button>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column *ngIf="!isArchived && !isClientManager" [width]="30">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <button class="link-button" (click)="deleteDocument(row)">
                        <i class="fa fa-trash fail-color"></i>
                    </button>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>
</div>
<div [ngClass]="{'nodoc-text': !showDocumentsList, 'nodoc-text-cm' : !showDocumentsList && isClientManager }" *ngIf="!showDocumentsList"> No documents to view</div>